export default {
    filterUnwantedFiles,
    isUnwantedFile
  };
  
  /**
   * กรองไฟล์ที่ไม่ต้องการออกจากรายการไฟล์
   * @param {FileList|Array} files - รายการไฟล์ที่ต้องการกรอง
   * @returns {Array} - รายการไฟล์ที่กรองแล้ว
   */
  function filterUnwantedFiles(files) {
    const skipFiles = ['Thumbs.db', 'thumbs.db', '.DS_Store', '.ds_store'];
    const skipExtensions = ['.tmp', '.ds_store', '.temp'];
    
    return Array.from(files).filter(file => {
      const fileName = file.name;
      
      // ตรวจสอบชื่อไฟล์ที่ต้องข้าม
      if (skipFiles.includes(fileName.toLowerCase())) {
        console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${fileName}`);
        return false;
      }
      
      // ตรวจสอบนามสกุลไฟล์ที่ต้องข้าม
      const fileExtension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
      if (skipExtensions.includes(fileExtension)) {
        console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${fileName}`);
        return false;
      }
      
      // ตรวจสอบไฟล์ที่มีรูปแบบ .temp ตามด้วยตัวเลข (เช่น test.temp 2)
      if (fileName.toLowerCase().match(/\.temp\s*\d*$/)) {
        console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${fileName}`);
        return false;
      }
      
      // ตรวจสอบไฟล์ที่มีรูปแบบ .tmp ตามด้วยตัวเลข (เช่น test.tmp 2)
      if (fileName.toLowerCase().match(/\.tmp\s*\d*$/)) {
        console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${fileName}`);
        return false;
      }
      
      // ตรวจสอบไฟล์ที่มีรูปแบบ .DS_Store ตามด้วยตัวเลข (เช่น .DS_Store 2)
      if (fileName.toLowerCase().match(/\.ds_store\s*\d*$/)) {
        console.log(`ข้ามไฟล์ที่ไม่ต้องการ: ${fileName}`);
        return false;
      }
      
      return true;
    });
  }
  
  /**
   * ตรวจสอบว่าไฟล์เป็นไฟล์ที่ไม่ต้องการหรือไม่
   * @param {string} fileName - ชื่อไฟล์ที่ต้องการตรวจสอบ
   * @returns {boolean} - true ถ้าเป็นไฟล์ที่ไม่ต้องการ, false ถ้าไม่ใช่
   */
  function isUnwantedFile(fileName) {
    const skipFiles = ['Thumbs.db', 'thumbs.db', '.DS_Store', '.ds_store'];
    const skipExtensions = ['.tmp', '.ds_store', '.temp'];
    
    // ตรวจสอบชื่อไฟล์ที่ต้องข้าม
    if (skipFiles.includes(fileName.toLowerCase())) {
      return true;
    }
    
    // ตรวจสอบนามสกุลไฟล์ที่ต้องข้าม
    const fileExtension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
    if (skipExtensions.includes(fileExtension)) {
      return true;
    }
    
    // ตรวจสอบไฟล์ที่มีรูปแบบ .temp ตามด้วยตัวเลข (เช่น test.temp 2)
    if (fileName.toLowerCase().match(/\.temp\s*\d*$/)) {
      return true;
    }
    
    // ตรวจสอบไฟล์ที่มีรูปแบบ .tmp ตามด้วยตัวเลข (เช่น test.tmp 2)
    if (fileName.toLowerCase().match(/\.tmp\s*\d*$/)) {
      return true;
    }
    
    // ตรวจสอบไฟล์ที่มีรูปแบบ .DS_Store ตามด้วยตัวเลข (เช่น .DS_Store 2)
    if (fileName.toLowerCase().match(/\.ds_store\s*\d*$/)) {
      return true;
    }
    
    return false;
  }
  